  import React from "react";
  import "./CommonModal.scss";

  const CommonModal = ({ onClose, children }) => {
     const handleOverlayClick = (e) => {
    // Only close if clicking on the overlay itself, not on the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
    return (
      <div className="common-modal-overlay" onClick={handleOverlayClick}>
        <div className="common-modal-content">
          {children}
        </div>
        <div className="common-modal-backdrop" onClick={onClose}></div>
      </div>
    );
  };

  export default CommonModal;
